<template>
   <div class="tarja-top" style="text-align: right; padding-right: 80px;">Olá, {{ formatarNome($store.state.user.aluno_nome) }}</div>
</template>
<script>
export default {
  data() {
    return {
      nome: ''
    }
  },

  methods: {
    formatarNome(nome) {
      return nome
        .toLocaleLowerCase('pt-BR')
        .replace(/\b\p{L}/gu, l => l.toLocaleUpperCase('pt-BR'));
    }
  }
}
</script>